<template>
<div style="width: 100%" class="landlord-page">
	<v-subheader>{{$t('landlords.landlords')}} > {{$t('landlords.landlord')}} #{{ $route.params.landlordId }} </v-subheader>
	<v-container grid-list-lg v-if="landlord">
		<v-card>
			<h3 class="caption-block">
				{{ $t('landlords.header') }}
			</h3>
			<v-card-title primary-title>
				<v-layout>
					<v-flex md4>
						<v-select
							:items="tituls1"
							:label="$t('landlords.titul_first')"
							v-model="landlord.titul_first"
						/>
					</v-flex>
					<v-flex md4>
						<v-select
							:items="tituls2"
							:label="$t('landlords.titul_second')"
							v-model="landlord.titul_second"
						/>
					</v-flex>
					<v-flex md4>
						<v-select
							:items="genders"
							:label="$t('workers.gender')"
							v-model="landlord.person_gender"
							item-text="name"
							item-value="key"
						/>
					</v-flex>
				</v-layout>
				<v-layout>
					<v-flex md3>
						<v-text-field :label="$t('workers.firstname')"
							v-model="landlord.person_firstname"
						/>
					</v-flex>
					<v-flex md3>
						<v-text-field :label="$t('workers.lastname')"
							v-model="landlord.person_lastname"
						/>
					</v-flex>
					<v-flex md3>
						<v-text-field :label="$t('workers.name')"
							v-model="landlord.landlord_name"
						/>
					</v-flex>
					<v-flex md3>
						<Datepicker :label="$t('workers.birth_date')"
							v-model="landlord.person_birth_date"
						/>
					</v-flex>
				</v-layout>
				<v-layout>
					<v-flex md6>
						<v-text-field :label="$t('landlords.person_document_id')"
							v-model="landlord.person_document_id"
						/>
					</v-flex>
					<v-flex md6>
						<v-text-field :label="$t('landlords.person_document_issuer')"
							v-model="landlord.person_document_issuer"
						/>
					</v-flex>
				</v-layout>
			</v-card-title>
		</v-card>
		<v-card class="address-block">
			<h3 class="caption-block">
				{{ $t('address.address') }}
			</h3>
			<v-card-title primary-title>
				<address-group
					:listAddress="landlord.landlord_apartment_address"
					:list-label="$t('address.apartment_address')"
					:main-address="landlord.landlord_person_address"
					:main-label="$t('address.person_address')"
					@createMultiple="createAddressMultiple"
					@update="updateAddressWithNotify"
					@createOne="createAddressOne"
					@delete="deleteAddressWithNotify"
				/>
			</v-card-title>
		</v-card>
		<v-layout d-flex justify-center align-content-center class="save-button">
			<v-tooltip top>
				<v-btn color="green lighten-1" class="white--text" slot="activator" @click="saveLandlord">
					<v-icon>save</v-icon>
					<span style="padding-left: 5px">{{$t('common.save')}}</span>
				</v-btn>
				<span>
					{{$t('landlords.save_landlord')}}
				</span>
			</v-tooltip>
		</v-layout>
	</v-container>
	<Loader v-if="isLoading" />
</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import Datepicker from '../components/DatePicker'
import AddressGroup from '../components/address-group/AddressGroup'
import Loader from '../components/Loader'
import { notify } from '../utils/notifications'

export default {
	data: vm => ({
		genders: [
			{ key: 'male', name: vm.$t('common.gender_male') },
			{ key: 'female', name: vm.$t('common.gender_female') },
		]
	}),
	components: {
		Datepicker,
		AddressGroup,
		Loader
	},
	created() {
		this.getLandlord()
	},
	methods: {
		...mapActions({
			getLandlord: 'landlords/getLandlord',
			updateLandlord: 'landlords/updateLandlord',
			createAddress: 'landlords/createAddress',
			updateAddress: 'landlords/updateAddress',
			deleteAddress: 'landlords/deleteAddress'
		}),
		saveLandlord() {
			this.updateLandlord(this.landlord).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.updated', {
						type: this.$t('workers.landlord')
					})
				})
			})
		},
		createAddressMultiple(data) {
			this.createAddress({
				...data,
				addressable_type: 'landlord_apartment_address'
			}).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.created', {
						type: this.$t('address.address')
					})
				})
			})
		},
		createAddressOne(data) {
			this.createAddress({
				...data,
				addressable_type: 'landlord_person_address'
			}).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.created', {
						type: this.$t('address.address')
					})
				})
			})
		},
		updateAddressWithNotify(data) {
			this.updateAddress(data).then(() => {
				this.$notify({
				...notify,
					text: this.$t('notifications.updated', {
						type: this.$t('address.address')
					})
				})
			})
		},
		deleteAddressWithNotify(id) {
			this.deleteAddress(id).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.deleted', {
						type: this.$t('address.address')
					})
				})
			})
		},
	},
	computed: {
		...mapState({
			landlord: ({ landlords }) => landlords.detail,
			isLoading: ({ landlords }) => landlords.isLoadingDetail
		}),
		...mapGetters({
			tituls1: 'settings/tituls1',
			tituls2: 'settings/tituls2'
		})
	}
}
</script>

<style>
.landlord-page .caption-block {
	font-size: 18px;
	text-align: center;
	padding-top: 10px;
}
.landlord-page .address-block {
	margin-top: 10px;
}
</style>
